import { createReducer } from "@reduxjs/toolkit";
import {
  setAsset,
  setEvent,
  setConstantTypes,
  setLessee,
  setLessor,
  setOwner,
  setBanks,
  setCurrencies,
  setRole,
  setPermission,
  setLoading,
  setLeaseBasicDetails,
  setAssembly,
  setRevisonHistory,
  setFileUploadDetails,
  setStorage,
  setUploadFiles,
  setSummryList,
  setUserLessorList,
  setForceChangePasswordModal,
  setForceChangePasswordModalData,
  setSelectedLessor
} from "./actions";

const initialState = {
  supplements: [],
  assetList: [],
  roleList: [],
  constantTypes: null,
  lessee: null,
  owner: [],
  lessor: [],
  event: [],
  permission: {},
  isLoading: false,
  banks:[],
  currencies:[],
  leaseBasicDetails: {},
  assemblysList:[],
  auditLog:[],
  fileUploadDetails:{},
  storageDetails:{},
  uploadFiles:{},
  summryList:{},
  userLessorList:[],
  forceChangePasswordModal: false,
  forceChangePasswordModalData: null,
  selectedLessor: null
};

export const sharedReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setAsset, (state, action) => {
      state.assetList = action?.payload;
    })
    .addCase(setConstantTypes, (state, action) => {
      state.constantTypes = action?.payload;
    })
    .addCase(setLessee, (state, action) => {
      state.lessee = action?.payload;
    })
    .addCase(setLessor, (state, action) => {
      state.lessor = action?.payload;
    })
    .addCase(setRole, (state, action) => {
      state.roleList = action?.payload;
    })
    .addCase(setPermission, (state, action) => {
      state.permission = action.payload;
    })
    .addCase(setEvent, (state, action) => {
      state.event = action?.payload?.list;
    })
    .addCase(setOwner, (state, action) => {
      state.owner = action?.payload;
    })
    .addCase(setBanks, (state, action) => {
      state.banks = action?.payload;
    })
    .addCase(setCurrencies, (state, action) => {
      state.currencies = action?.payload;
    })
    .addCase(setLoading, (state, action) => {
      state.isLoading = action.payload;
    })
    .addCase(setLeaseBasicDetails, (state, action) => {
      state.leaseBasicDetails = action?.payload;
    })
    .addCase(setAssembly, (state, action) => {
      state.assemblysList = action?.payload;
    })
     .addCase(setRevisonHistory, (state, action) => {
      state.auditLog = action?.payload;
    })
    .addCase(setFileUploadDetails, (state, action) => {
      state.fileUploadDetails = action?.payload;
    })
     .addCase(setStorage, (state, action) => {
      state.storageDetails = action?.payload;
    })
    .addCase(setUploadFiles,(state,action)=>{
      state.uploadFiles=action?.payload;
    })
    .addCase(setSummryList, (state, action) => {
      state.summryList = action?.payload;
    })
    .addCase(setUserLessorList, (state, action) => {
      state.userLessorList = action?.payload;
    })
    .addCase(setForceChangePasswordModal, (state, action) => {
      state.forceChangePasswordModal = action?.payload;
    })
    .addCase(setForceChangePasswordModalData, (state, action) => {
      state.forceChangePasswordModalData = action?.payload;
    })
    .addCase(setSelectedLessor, (state, action) => {
      state.selectedLessor = action?.payload;
    });
});
